import { inventoryApi } from "@/services/api/inventory.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";

export const inventoryState = {
  state: {
    inventory: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false,
    is_any_open: false,
    error: ""
  },
  mutations: {
    INVENTORY_FETCH_SUCCESS(state, payload) {
      state.inventory = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
      // state.is_any_open = payload.is_any_open;
    },
    INVENTORY_FETCH_START(state) {
      state.fetching = true;
    },
    INVENTORY_FETCH_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    INVENTORY_SAVE_SUCCESS(state, payload) {
      if (payload.index > -1) {
        // update
        // letörli a (payload.index)-ű elemet
        state.inventory.splice(payload.index, 1, payload.data);
        // és betölti a data elemet
        // state.supplyAreas[payload.index] = payload.data;
      } else {
        // add
        state.inventory.push(payload.data);
      }
    },
    INVENTORY_SAVE_START(state) {
      state.fetching = true;
    },
    INVENTORY_SAVE_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },

    // IS ANY OPEN?
    INVENTORY_IS_ANY_OPEN_SUCCESS(state, payload) {
      state.is_any_open = payload.isAnyOpen;
      state.fetching = false;
      state.loading = false;
    },
    INVENTORY_IS_ANY_OPEN_START(state) {
      state.fetching = true;
      state.loading = true;
    },
    INVENTORY_IS_ANY_OPEN_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },
    // save
    INVENTORY_COUNT_SUCCESS(state, payload) {
      // console.log('result: ', payload);
      if (payload.index > -1) {
        // update
        // letörli a (payload.index)-ű elemet
        state.inventory[payload.index].itemCount = payload.totalCount;
      } else {
        // console.log("INVENTORY_COUNT_SUCCESS: fuckup");
        appSnackbarService.error("INVENTORY_COUNT_SUCCESS: fuckup");
      }
    },
    INVENTORY_COUNT_START(state) {
      state.fetching = true;
    },
    INVENTORY_COUNT_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },
  },
  actions: {
    getInventory(context, request) {
      context.commit("INVENTORY_FETCH_START");

      const promise = new Promise((resolve, reject) => {
        inventoryApi
        .getAll(request)
          .then(response => {
            context.commit("INVENTORY_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            context.commit("INVENTORY_FETCH_ERROR", error);
            reject(error);
          });
        });
      return promise;
    },
    inventoryNew(context, payload) {
      context.commit("INVENTORY_SAVE_START");

      const editedIndex = payload.index;
      const promise = new Promise((resolve, reject) => {

        inventoryApi
        .new(payload.data)
          .then(response => {
            context.commit("INVENTORY_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.INVENTORY_CREATED"));
            resolve(response);
          })
          .catch(error => {
            context.commit("INVENTORY_SAVE_ERROR", error);
            // appSnackbarService.error(error);
            reject(error);
          });
        });
      return promise;
    },
    inventoryClose(context, payload) {
      context.commit("INVENTORY_SAVE_START");

      const editedIndex = payload.index;
      const promise = new Promise((resolve, reject) => {

        inventoryApi
        .close({id: payload.data.inventoryId})
          .then(response => {
            context.commit("INVENTORY_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            resolve(response);
          })
          .catch(error => {
            context.commit("INVENTORY_SAVE_ERROR", error);
            // appSnackbarService.error(error);
            reject(error);
          });
        });
      return promise;
    },
    inventoryIsAnyOpen(context) {
      context.commit("INVENTORY_IS_ANY_OPEN_START");

      const promise = new Promise((resolve, reject) => {

        inventoryApi
        .isAnyOpen()
          .then(response => {
            context.commit("INVENTORY_IS_ANY_OPEN_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            context.commit("INVENTORY_IS_ANY_OPEN_ERROR", error);
            // appSnackbarService.error(error);
            reject(error);
          });
        });
      return promise;
    },
    getInventoryAll(context, request) {
      // context.commit("INVENTORY_ALL_START");
      const promise = new Promise((resolve, reject) => {

        inventoryApi
        .allForExcel(request)
          .then(response => {
            // context.commit("INVENTORY_ALL_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            // context.commit("INVENTORY_ALL_ERROR", error);
            reject(error);
          });
        });
      return promise;
    },
    getInventoryItemCount(context) {

      context.commit("INVENTORY_COUNT_START");

      const promise = new Promise((resolve) => {
        // TODO: solve this count problem.
        // let promise_arr = []
        // for(let i= 0; i < this.state.inventory.inventory.length; i++) {
        //   // retrieve the items...
        //   const item = this.state.inventory.inventory[i];
        //   // console.log('count: ', item);
        //   promise_arr.push(inventoryItemsApi.count(item._id)
        //   .then(res => {
        //     context.commit("INVENTORY_COUNT_SUCCESS", {...res, id: item._id, index: i});
        //   })
        //   .catch( err => {
        //     context.commit("INVENTORY_COUNT_ERROR", err);
        //   }));
        // }
        // Promise.all(promise_arr)
        // .then( () => {
        //   resolve();
        // });

        resolve();
      });
      return promise;
    }
  },
};
